<template>
  <div :class="linkClass" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
    <audio ref="msgMP3" src="http://yunqiaoapp.oss-cn-hangzhou.aliyuncs.com/uploads/images/file/202203/19/243_1647661961_aO7J.mp3"></audio>
    <div class="linkChat">
      <el-row>
        <el-col :span="24">
          <el-card class="linkChat-right" shadow="always">
            <div slot="header" class="chatTitle" :style="{'backgroundColor':style.themeColor,'color':style.fontColor}">
              <img class="teamLogo" :src="teamInfo.logo">
              <span class="teamSlogan">{{teamInfo.teamTitle}}</span>
              <el-link style="float: right" v-if="beforeUrl" :href="beforeUrl" :underline="false"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-guanbi1"></use></svg></el-link>
            </div>
            <el-row class="YQ-linkChat-right-content">
              <el-col :span="4" v-show="leftNone">
                <el-card class="robotList" shadow="never">
                  <div class="xxl">
                    <span>信息栏导航</span>
                  </div>
                  <div v-for="(robotItem, index) in robotList" :key="index" class="robotoItem">
                    <el-link :underline="false" type="primary" @click="robotReply(robotItem.reply)">{{ robotItem.problem }}</el-link>
                  </div>
                  <div style="width: 117px;height: 117px;position: absolute; bottom: 40px">
                    <img style="width: 100%;height: 100%" :src="QRCode">
                  </div>
                </el-card>
              </el-col>
              <el-col :span="linkChatSpan">
                <div class="YQ_linkChat-middle">
                  <div class="YQ-ChatMessage YQ-linkChatMessage">
                    <div v-show="cardShow" class="YQ-user-message" @click="sendCard">
                      <div class="YQ-user-message-title"><span v-html="cardTip"></span></div>
                      <div class="YQ-user-message-content">
              <span class="YQ-text-wrap" style="width: 75%;height: 100px;background-color: #F2F6FC">
                <div>
                  <div style="display: flex">
                    <img style="width: 80px; height: 80px" :src="cards.image">
                    <div style="overflow: hidden;height: 50px;margin-left: 16px" v-html="cards.desc"></div>
                  </div>
                </div>
                <p style="font-size: 12px; line-height: 1;margin: 6px 0;color: #909399" v-html="cards.title"></p>
              </span>
                      </div>
                      <div class="clear" style="clear: both;"></div>
                    </div>
                    <div v-for="(messageItem, index) in messageList">

                      <div class="YQ-service-message" v-if="messageItem.role === 'service'">
                        <div class="YQ-service-message-left">
                          <img :src="messageItem.favicon">
                        </div>
                        <div class="YQ-service-message-right">
                          <div class="YQ-service-message-title">
                            <span>{{messageItem.nickname}} {{messageItem.time}}</span>
                          </div>
                          <div class="YQ-service-message-content" v-html="messageItem.msg"></div>
                        </div>
                        <div class="clear" style="clear: both;"></div>
                      </div>
                      <div class="YQ-user-message" v-if="messageItem.role === 'user'">
                        <div class="YQ-user-message-title"><span>{{messageItem.time}}</span></div>
                        <div class="YQ-user-message-content">
                          <span class="YQ-text-wrap" :style="{'backgroundColor':style.themeColor,'color':style.fontColor}" v-html="messageItem.msg"></span>
                        </div>
                        <div class="clear" style="clear: both;"></div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="YQ_linkChat-middle-bottom">
                  <div>
                    <el-input type="textarea" class="YQ_linkChat-middle-ChatCenter" :placeholder="placeholderTitle" v-model="message" @keyup.enter.native="listen"></el-input>
                  </div>
                  <div>
                    <el-popover placement="top-start" width="363" trigger="click" v-model="emojiVisible">
                      <div class="emoji">
                        <el-link v-for="emoji in emojis" :key="emoji.id" :underline="false" @click="clickEmoji(emoji)"><img :src='emoji'></el-link>
                      </div>
                      <el-link class="functionIco" slot="reference" :underline="false"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-_biaoqing"></use></svg></el-link>
                    </el-popover>

                    <el-upload
                        style="display: inline"
                        action=""
                        :http-request="uploadImg"
                        :show-file-list="false"
                        accept="image/*"
                        list-type="picture">
                      <el-link class="functionIco" :underline="false"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-tupian"></use></svg></el-link>
                    </el-upload>

                    <el-upload
                        style="display: inline"
                        action=""
                        :http-request="uploadFile"
                        :show-file-list="false"
                        accept="file/*"
                        list-type="picture">
                      <el-link class="functionIco" :underline="false"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-wenjian"></use></svg></el-link>
                    </el-upload>

                    <el-popover placement="top-start" width="363" offset="106" trigger="click" v-model="rateVisible">
                        <span>请对本次服务进行评价， 感谢您提出的宝贵意见！</span>
                        <span>
                          <el-rate class="smallRate" v-model="rate" show-text>
                          </el-rate>
                        </span>
                        <span>
                          <el-input
                              type="textarea"
                              :rows="4"
                              placeholder="请对本次服务提出您宝贵的意见 ！"
                              v-model="rateText">
                          </el-input>
                        </span>
                        <span><el-button :style="{'backgroundColor':style.themeColor,'color':style.fontColor, 'border': 'none'}" @click="postRate" class="smallRateButton" type="primary">提交</el-button></span>

                      <el-link class="functionIco" slot="reference" :underline="false"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-pingjia"></use></svg></el-link>
                    </el-popover>

                    <el-button class="YQ-chatSend" :style="{'backgroundColor':style.themeColor,'color':style.fontColor,'border': 'none'}" type="primary" :disabled="disabledSend" size="mini" @click="send">{{sendTitle}}</el-button>
                  </div>
                </div>
                <!--  底部软件声明-->
                <div v-show="chatAD" class="YQ-footer-support"><el-link :underline="false">云桥在线客服系统</el-link></div>
              </el-col>
              <el-col :span="8" v-show="rightNone">
                <div v-show="!robotRightState"><a :href="style.rightLink" target="_blank"><img class="YQ-bigAD" :src="style.rightImage"></a></div>
                <div v-show="robotRightState" style="border-left: 1px solid #e4e7f1;">
                  <div style="height: 133px">
                    <el-card>
                      <div style="padding-top: 20px;padding-left: 12px;padding-right: 24px;">
                        <span style="border: 1px solid #3d88f2;border-radius: 1.5px;margin-right: 8px;"></span>
                        <span>{{robotRightTop.title}}</span>
                      </div>
                      <div>
                        <el-button v-for="(item, index) in robotRightTop.list" :key="index" style="margin: 12px 0 0 6px;" size="mini" round @click="robotReply(item.content)">{{item.title}}</el-button>
                      </div>
                    </el-card>
                  </div>
                  <div style="height: 240px">
                    <el-card>
                      <div style="padding-top: 20px;padding-left: 12px;padding-right: 24px;">
                        <span style="border: 1px solid #3d88f2;border-radius: 1.5px;margin-right: 8px;"></span>
                        <span>{{robotRight.title}}</span>
                      </div>
                      <div>
                        <div v-for="(item, index) in robotRight.list" :key="index" style="margin: 12px">
                          <div style="width: 50px;height: 50px;float: left;margin-top: 16px;">
                            <img style="width: 50px;height: 50px;border-radius: 50%;" src="http://yunqiaoapp.oss-cn-hangzhou.aliyuncs.com/uploads/images/favicon/202204/21/6_1650537509_tWD2.jpg">
                          </div>
                          <div style="float: left;margin-left: 10px">
                            <div>
                              <span style="font-size: 14px;line-height: 20px;font-weight: bolder;">{{item.title}}</span>
                            </div>
                            <div style="font-size: 14px;width: 240px;height:55px;line-height: 20px;color: #666;overflow:hidden;" v-html="item.content"></div>
                          </div>
                          <div class="clear" style="clear: both;"></div>
                        </div>
                      </div>
                    </el-card>
                  </div>
                  <div style="height: 180px">
                    <el-card>
                      <div style="padding-top: 20px;padding-left: 12px;padding-right: 24px;">
                        <span style="border: 1px solid #3d88f2;border-radius: 1.5px;margin-right: 8px;"></span>
                        <span>{{robotRightBottom.title}}</span>
                      </div>
                      <div>
                        <div v-for="(item, index) in robotRightBottom.list" :key="index" style="font-size: 14px;line-height: 26px;margin: 6px 14px"><el-link :underline="false" @click="robotReply(item.content)">{{item.title}}</el-link></div>
                      </div>
                    </el-card>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import { createSocket, sendWSPush} from '../../assets/js/websocket'
import {mapMutations} from 'vuex'
export default {
  name: "webLink",
  data() {
    return {
      teamID: '',
      YQToken: '',
      beforeUrl: false,
      message: '',
      messageList: [],
      loading: true,
      robotList: [],
      numberReply: [],
      style: {},
      teamInfo: {},
      rateVisible: false,
      rate:3,
      rateText:'',
      disabledSend: false,
      emojiVisible: false,
      robotInfo:[],
      chatAD: true,
      leftNone: true,
      rightNone: true,
      linkChatSpan: 12,
      sendTitle: '发送',
      placeholderTitle: '请输入内容',
      emojis: [
        'http://yunqiaoapp.oss-cn-hangzhou.aliyuncs.com/uploads/images/file/202203/19/317_1647679104_izly.gif',
        'http://yunqiaoapp.oss-cn-hangzhou.aliyuncs.com/uploads/images/file/202203/19/891_1647679136_d0Ag.gif',
        'http://yunqiaoapp.oss-cn-hangzhou.aliyuncs.com/uploads/images/file/202203/19/588_1647679160_NTbH.gif',
        'http://yunqiaoapp.oss-cn-hangzhou.aliyuncs.com/uploads/images/file/202203/19/137_1647679188_cDSJ.gif',
        'http://yunqiaoapp.oss-cn-hangzhou.aliyuncs.com/uploads/images/file/202203/19/195_1647679210_jl2x.gif',
        'http://yunqiaoapp.oss-cn-hangzhou.aliyuncs.com/uploads/images/file/202203/19/945_1647679235_V9TR.gif',
        'http://yunqiaoapp.oss-cn-hangzhou.aliyuncs.com/uploads/images/file/202203/19/661_1647679262_P8QC.gif',
        'http://yunqiaoapp.oss-cn-hangzhou.aliyuncs.com/uploads/images/file/202203/19/435_1647679282_yjww.gif',
        'http://yunqiaoapp.oss-cn-hangzhou.aliyuncs.com/uploads/images/file/202203/19/296_1647679302_qknV.gif',
        'http://yunqiaoapp.oss-cn-hangzhou.aliyuncs.com/uploads/images/file/202203/19/500_1647679547_itVQ.gif',
      ],
      cards: '',
      cardShow: false,
      cardTip: '点击下方发送卡片信息',
      robotRightState: false,
      robotRightTop: [],
      robotRight: [],
      robotRightBottom: [],
      linkClass: 'link',
      QRCode: '',
    }
  },

  mounted() {
    this.teamID = this.$route.query.teamID
    this.YQToken = localStorage.getItem("YQToken"+this.teamID)
    this.YQNickname = this.$route.query.YQNickname
    this.uuid = this.$route.query.uuid
    this.beforeUrl = this.$route.query.beforeUrl
    this.platform = this.$route.query.platform
    this.platformVersion = this.$route.query.platformVersion
    this.browser = this.$route.query.browser
    this.cards = this.$route.query.cards
    createSocket();
    this.getChatInfo();
    const getsocketData = e => {  // 创建接收消息函数

      if(e && e.detail.data === 'Y')
      {
        return ;
      }
      const data = JSON.parse(e && e.detail.data);

      if (data.code === '0000')
      {
        let socketData = {};
        socketData.type = 'visitor';//用户
        socketData.code = '6000';//连接
        socketData.teamID = this.teamID;//
        socketData.token = this.YQToken;//
        socketData.uuid = this.uuid;//
        socketData.platform = 'Windows';//
        socketData.platformVersion = 'Windows 10.0';//
        socketData.browser = 'Chrome98.0.4750.0';//
        socketData.YQNickname = this.YQNickname;//
        socketData.source = 'hyperlink'; //
        socketData.url = '超链接'; //轨迹
        socketData.referrer = '超链接'; //来源
        socketData.eqid = 'hyperlink';//
        sendWSPush(socketData)
      }
      if (data.code === '9000')
      {
        //存储YQToken
        localStorage.setItem("YQToken"+this.teamID,data.YQToken);
        this.YQToken = data.YQToken
        let socketData = {};
        socketData.type = 'visitor';//用户
        socketData.code = '6001';//连接
        sendWSPush(socketData)
      }

      //接收消息
      if (data.code === '9004')
      {
        this.$refs.msgMP3.play();//点击触发 点击音效
        let messageItem = {};
        messageItem.role = 'service';
        messageItem.onlyID = data.onlyID;
        messageItem.msg = data.message;
        messageItem.favicon = data.favicon;
        messageItem.time = data.time;
        messageItem.nickname = data.nickname;
        this.messageList.push(messageItem)
      }
      if (data.code === '9005')
      {
        //消息撤回
        let $this = this;
        this.messageList.forEach(function (item,key) {

          if (item.onlyID === data.onlyID)
          {
            $this.messageList.splice(key, 1);
          }
        });
      }
      //屏蔽访客
      if (data.code === '9003')
      {
        if (data.type === 'forever')
        {
          //永久屏蔽
          localStorage.setItem("shield"+this.teamID,'999999');
          window.location.href = 'https://www.baidu.com/';
        }
        if (data.type === 'skip')
        {
          //跳转到其它页面
          window.location.href = 'https://www.baidu.com/';
        }
      }

    }
    //  注册监听事件
    window.addEventListener('onmessageWS', getsocketData)
    if (this.cards !== 'undefined')
    {
      this.cardShow = true
      this.cards = JSON.parse(this.cards);
    }
    if (this.teamID === '31a73485-08d5-4356-bbf5-e79bf3c50bf8')
    {
     this.linkClass = 'zsLink';
    }
  },

  methods:{
    ...mapMutations(['initialize']),

    //获取账号信息
    getChatInfo()
    {
      this.$https({url: 'chatStyle?teamID='+this.teamID+'&YQToken='+this.YQToken+'&chat_type=big',method: "get"}).then(backData => {
        if (backData.data.status === 200)
        {
          this.robotList = backData.data.data.robotList;
          this.numberReply = backData.data.data.numberReply;
          this.style = backData.data.data.style;
          this.teamInfo = backData.data.data.teamInfo;
          this.robotRightState = backData.data.data.robotRightState;
          this.robotRightTop = backData.data.data.robotRightTop;
          this.robotRight = backData.data.data.robotRight;
          this.robotRightBottom = backData.data.data.robotRightBottom;
          this.QRCode = backData.data.data.QRCode;
          if (this.teamInfo.chatAD === '1')
          {
            this.chatAD = false
          }
          if (this.style.autoLeft === '0' && this.style.autoRight === '0')
          {
            this.leftNone = false
            this.rightNone = false
            this.linkChatSpan = 24
          }
          if (this.style.autoLeft === '0' && this.style.autoRight === '1')
          {
            this.leftNone = false
            this.linkChatSpan = 18
          }
          if (this.style.autoLeft === '1' && this.style.autoRight === '0')
          {
            this.rightNone = false
            this.linkChatSpan = 18
          }
          this.loading = false
          this.messageList = backData.data.data.messageList;
          this.robotInfo = backData.data.data.robotInfo;
          if (this.robotInfo.winLong === '1')
          {
            this.sendTitle = 'send'
            this.placeholderTitle = 'Please enter the content'
          }
          this.initialize(backData.data.data.user);
        }
      });
    },
    //评价
    appraise()
    {
      this.rateVisible = true
    },
    postRate()
    {
      let data = {}
      data.teamID = this.teamID
      data.YQToken = this.YQToken
      data.rate = this.rate
      data.rateText = this.rateText
      this.$https({url: 'userRate',data,method: "post"}).then(backData => {
        if (backData.data.status === 200)
        {
          this.rateVisible = false
          this.rateText = ''
          this.$notify({title: '评价成功!',message: '感谢您的支持！',type: 'success'});
        }
      });
      let socketData = {}
      socketData.type = 'visitor';//用户
      socketData.code = '6004';//发送消息
      socketData.msg = '该访客对你本次对话做出了评价：【评价等级】'+this.rate+'颗星。'+'【评价内容】'+this.rateText;//关闭窗口
      sendWSPush(socketData)
    },
    sendCard()
    {
      let socketData = {}
      socketData.type = 'visitor';//用户
      socketData.code = '6004';//发送消息
      socketData.msg = '【卡片信息】：'+this.card.title;
      this.postMessage(socketData)
      this.cardTip = ''
    },
    clickEmoji(emoji)
    {
      this.emojiVisible = false
      let socketData = {}
      socketData.type = 'visitor';//用户
      socketData.code = '6004';//发送消息
      socketData.msg = '<img style="width: 60px" src="'+emoji+'">';
      sendWSPush(socketData)
      let messageItem = {};
      messageItem.role = 'user';
      messageItem.msg = '<img style="width: 60px" src="'+emoji+'">';
      if (this.robotInfo.winLong === '1')
      {
        messageItem.time = 'me';
      } else {
        messageItem.time = '我的';
      }
      this.messageList.push(messageItem)
    },
    uploadImg(param)
    {
      let image = new FormData();
      image.append("file",param.file);
      this.$https({url: 'uploadImage',data:image,method: "post"}).then(backData => {
        if (backData.data.status === 200)
        {
          let socketData = {}
          socketData.type = 'visitor';//用户
          socketData.code = '6004';//发送消息
          socketData.msg = '<a href="'+backData.data.data+'" target="_Blank"><img style="width: 200px" src="'+backData.data.data+'"></a>';
          sendWSPush(socketData)
          let messageItem = {};
          messageItem.role = 'user';
          messageItem.msg = '<a href="'+backData.data.data+'" target="_Blank"><img style="width: 200px" src="'+backData.data.data+'"></a>';
          if (this.robotInfo.winLong === '1')
          {
            messageItem.time = 'me';
          } else {
            messageItem.time = '我的';
          }
          this.messageList.push(messageItem)
        }
      });
    },
    uploadFile(param)
    {
      let file = new FormData();
      file.append("file",param.file);
      this.$https({url: 'uploadFile',data:file,method: "post"}).then(backData => {
        if (backData.data.status === 200)
        {
          let socketData = {}
          socketData.type = 'visitor';//用户
          socketData.code = '6004';//发送消息
          socketData.msg = '<a href="'+backData.data.data+'" target="_Blank">'+backData.data.filename+'</a>';
          sendWSPush(socketData)
          let messageItem = {};
          messageItem.role = 'user';
          messageItem.msg = '<a href="'+backData.data.data+'" target="_Blank">'+backData.data.filename+'</a>';
          if (this.robotInfo.winLong === '1')
          {
            messageItem.time = 'me';
          } else {
            messageItem.time = '我的';
          }
          this.messageList.push(messageItem)
        }
      });
    },
    send() {
      if(this.message.length === 0||this.message.split(" ").join("").length === 0){
        this.$message({message: '不能发送空消息，请从新输入！',type: 'warning'});
      }else{
        let socketData = {}
        socketData.type = 'visitor';//用户
        socketData.code = '6004';//发送消息
        socketData.msg = this.message;//关闭窗口
        sendWSPush(socketData)
        let messageItem = {};
        messageItem.role = 'user';
        messageItem.msg = this.message;
        if (this.robotInfo.winLong === '1')
        {
          messageItem.time = 'me';
        } else {
          messageItem.time = '我的';
        }
        this.messageList.push(messageItem)
        //判断是否需要数字回复
        let $this = this
        this.numberReply.forEach(function (item) {
          if (item.problem === $this.message.trim())
          {
            //发送机器人回复
            $this.robotReply(item.reply)
          }
        })
        this.message = ''
      }
    },
    scrollToBottom() {
      let container = document.getElementsByClassName('YQ_linkChat-middle')[0];
      container.scrollTop = container.scrollHeight;
    },
    //监听回车键
    listen (e) {
      if(e.ctrlKey && e.keyCode==13) { //用户点击了ctrl+enter触发
        this.message += '\n';
      }else { //用户点击了enter触发
        if(this.message.length === 1||this.message.split(" ").join("").length === 0){
          this.message = ''
          return this.$message({message: '不能发送空消息，请从新输入！',type: 'warning'});
        }
        this.send() // 发送文本
      }
    },
    robotReply (reply) {
      let messageItem = {};
      messageItem.role = 'service';
      messageItem.msg = reply;
      messageItem.favicon = this.robotInfo.robotIcon;
      messageItem.nickname = this.robotInfo.robotNickname;
      this.messageList.push(messageItem)
      //发送机器人消息
      let socketData = {}
      socketData.type = 'visitor';//用户
      socketData.code = '6005';//发送消息
      socketData.msg = reply;//
      socketData.favicon = this.robotInfo.robotIcon;
      socketData.nickname = this.robotInfo.robotNickname;
      sendWSPush(socketData)
    }
  },
  updated() {
    this.scrollToBottom()
  },
  watch: {
    message:function (newMessage){
      let socketData = {}
      socketData.type = 'visitor';//用户
      socketData.code = '6003';//发送消息
      socketData.msg = newMessage;//关闭窗口
      sendWSPush(socketData)
    }
  },
}
</script>

<style>
.link{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #7474BF;
  background: -webkit-linear-gradient(to right, #348AC7, #7474BF);
  background: linear-gradient(to right, #348AC7, #7474BF);
  background-size: cover;
}
.zsLink {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #424242;
  color: rgb(24, 24, 24);
  background-size: cover;
}
.linkChat{
  width: 1000px;
  height: 600px;
  background-color: #1b7ee1;
  margin: 0 auto;
}

.linkChat .el-card{
  height: 100%;
}
.xxl {
  border-bottom: 1px solid #e4e7f1;
  color: #000;
  font-family: PingFangSC-Medium,serif;
  font-size: 16px;
  padding: 19px 0;
}
.robotList{
  padding: 0 24px;
  background-color: #f2f6f7;
  border-right: 1px solid #ebeef5 !important;
}
.linkChat .el-card__header {
  padding: 12px 10px;
  background-color: #1798fc;
  border: none;
}
.linkChat .el-card__body {
  padding: 0;
  height: 100%;
}
.robotoItem {
  margin: 15px;
}
.robotoItem a {
  font-size: 16px;
  color: #555 !important;
}
.teamLogo{
  width: 32px;
  height: 32px;
  position: absolute;
  top: 8px;
}
.teamSlogan{
  margin-left: 36px;
}
.linkChat-right{
  height: 100%;
}
.YQ-linkChat-right-content{
  height: calc(100% - 45px);
}
.YQ_linkChat-middle{
  height: calc(100% - 113px);
  overflow-y: auto;
}
.YQ-bigAD{
  width: 100%;
  height: 100%;
}
.YQ_linkChat-middle-content{
  height: calc(100% - 113px);
}
.YQ_linkChat-middle-bottom{
  height: 90px;
  border-top: 1px solid #e4e7f1;
  border-bottom: 1px solid #e4e7f1;
  background-color: #fff;
}
.YQ_linkChat-middle-ChatCenter > .el-textarea__inner{
  resize: none;
  border: 0;
  word-break:break-all;
  word-wrap:break-word;
  height: 60px !important;
}
.YQ-linkChatMessage{
  margin-bottom: 20px;
}
.YQ-footer-support{
  text-align: center;
  line-height: 16px;
}
.YQ-footer-support a{
  color: #b3b3b3 !important;
  font-size: 12px;
}
.smallRate{
  text-align: center;
  height: 30px;
  margin: 12px 0;
}
.smallRate span i{
  font-size: 30px;
}
.smallRateButton{
  width: 100%;
  margin-top: 12px;
}
.emoji img{
  width: 60px;
  margin: 0 6px;
}
.linkChat-right .el-card__header{
  padding: 0;
  border: none;
}
.chatTitle{
  padding: 12px 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/link/webLink.vue